// If Needs to import any script:
// import { tns } from 'tiny-slider';

document.addEventListener(
	'DOMContentLoaded',
	function () {
		document.querySelectorAll('.faq-card').forEach(card => {
            card.addEventListener('click', () => {
                let answer = card.querySelector('.faq-card__answer');
                let isActive = card.classList.contains('active');
                
                document.querySelectorAll('.faq-card').forEach(c => {
                    c.classList.remove('active');
                    c.querySelector('.faq-card__answer').style.maxHeight = null;
                });
                
                if (!isActive) {
                    card.classList.add('active');
                    answer.style.maxHeight = answer.scrollHeight + "px";
                }
            });
        });
	},
	false
);
